import React, { FC } from 'react';

import { useNavigation } from 'hooks/navigation/use-navigation';
import { useCart } from 'hooks/use-cart';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { useServiceModeContext } from 'state/service-mode';

import { SimpleHomePageDesktop } from './simple-home-page-desktop';
import { SimpleHomePageMobile } from './simple-home-page-mobile';
import { ISimpleHomePageItemProps } from './types';

const SimpleHomePage: FC<React.PropsWithChildren<ISimpleHomePageItemProps>> = ({
  item,
  flatListDimensions,
}) => {
  const { navigate } = useNavigation();
  const isMobile = useIsMobileBreakpoint();
  const { serviceMode } = useServiceModeContext();

  const { numberOfItemsInCart } = useCart();

  return isMobile ? (
    <SimpleHomePageMobile
      flatListDimensions={flatListDimensions}
      item={item}
      serviceMode={serviceMode}
      navigate={navigate}
      numberOfItemsInCart={numberOfItemsInCart}
    />
  ) : (
    <SimpleHomePageDesktop
      flatListDimensions={flatListDimensions}
      item={item}
      navigate={navigate}
      serviceMode={serviceMode}
      numberOfItemsInCart={numberOfItemsInCart}
    />
  );
};

export default React.memo(SimpleHomePage);
